const enums = {
	employmentType: [
		{ value: 1, label: "Permanent" },
		{ value: 2, label: "Casual" },
		{ value: 3, label: "Fixed Term" },
		{ value: 4, label: "Grounds Maintenance Operator-Permanent" },
		{ value: 5, label: "Grounds Maintenance Operator-Casual" },
		{ value: 6, label: "Maintenance Technician-Permanent" },
	],
	jobPosition: [
		{ value: "Cleaner", label: "Cleaner" },
		// { value: "Cleaner (Cleaner)", label: "Cleaner (Cleaner)" },
		{ value: "Area Supervisor", label: "Area Supervisor" },
		{ value: "Supervisor", label: "Supervisor" },
		{ value: "Grounds Maintenance Operator", label: "Grounds Maintenance Operator"},
		{ value: "Maintenance Technician", label: "Maintenance Technician"},
	],
	schoolCleanerWeeks: [
		{ value: 39, label: "39 weeks" },
		{ value: 40, label: "40 weeks" },
		{ value: 41, label: "41 weeks" },
		{ value: 42, label: "42 weeks" },
		{ value: 44, label: "44 weeks" },
		{ value: 46, label: "46 weeks" },
		{ value: 48, label: "48 weeks" },
		{ value: 49, label: "49 weeks" },
	],
	candidateIdentityDocumentType: [
		{
			value: 1,
			label: "New Zealand Driver License",
			documentNumberLabel: "License number",
			expiryLabel: "License expiry date",
			mode: "license",
			files: {
				"dl-front": "Front of License",
				"dl-back": "Back of License",
			},
			otherInformation: {
				class: { name: "License class" },
			},
		},
		{
			value: 2,
			label: "New Zealand Passport",
			documentNumberLabel: "Passport number",
			expiryLabel: "Passport expiry date",
			files: {
				"nzp-photo-page": "Photo Page",
				"nzp-signature-page": "Signature Page",
			},
			mode: "nz-passport",
		},
		{
			value: 3,
			label: "International Passport",
			documentNumberLabel: "Passport number",
			expiryLabel: "Passport expiry date",
			files: { "ip-photo-page": "Photo Page" },
			mode: "intl-passport",
		},
		{ value: 100, label: "None", mode: "none" },
	],
	kiwisaverStatus:["Not Eligible","Auto Enrol","Existing","Opt In","Opt Out"],
	kiwisaverContributionRate:["N/A","3.5%","4%","6%","8%","10%"],
	candidateResidencyStatus: [
		{ value: 1, label: "New Zealand Citizen" },
		{ value: 2, label: "New Zealand Permanent Resident" },
		{ value: 5, label: "Residency Visa" },
		{ value: 10, label: "Open Work Visa" },
		{ value: 11, label: "Essential Skills Work Visa" },
		{ value: 15, label: "Accredited Employer Visa" },
		{ value: 20, label: "Student Visa" },
		{ value: 25, label: "Interim Visa" },
		{ value: 30, label: "Working Holiday Visa" },
		{ value: 40, label: "Australian Citizen" },
	 ],
	 candidateProgress:[
		{
			value: 0,
			key: "InitialCandidateReview",
			label: "Initial Candidate Review",
			kind: "black",
			variant: "outlined",
			noteRequired: false,
		},
		{
			value: 1,
			key: "CreatedCandidateLogin",
			label: "Created Candidate Login",
			kind: "blue",
			variant: "outlined",
			noteRequired: false,
		},
		{
			value: 2,
			key:"CandidateTasksInProgress",
			label: "Candidate Tasks In Progress",
			kind: "blue",
			variant: "solid",
			noteRequired: false,
		},
		{
			value: 3,
			key: "PreJobOfferReview",
			label: "Pre Job Offer Review",
			kind: "green",
			variant: "outlined",
			noteRequired: false,
		},
		{
			value: 4,
			key:"JobOffered",
			label: "Job Offered",
			kind: "green",
			variant: "solid",
			noteRequired: false,
		},
		{
			value: 5,
			key: "FinalReview",
			label: "Final Review",
			kind: "orange",
			variant: "outlined",
			noteRequired: false,
		},
		{
			value: 6,
			key: "SentToZambion",
			label: "Sent to Zambion",
			kind: "orange",
			variant: "solid",
			noteRequired: false,
		}
	 ],
	candidateMojStatus: [
		{
			value: 1,
			key: "AwaitingCandidateDetail",
			label: "Waiting for Candidate Detail",
			labelShort: "Waiting for Candidate",
			kind: "black",
			variant: "outlined",
			noteRequired: true,
			special: [
				"reminder-notify-candidate",
				"optional-clear-all",
				"optional-clear-identity-document",
				"optional-clear-residency",
			],
		},
		{
			value: 10,
			key: "CandidateDetailComplete",
			label: "Candidate Detail Complete - Ready for MOJ",
			labelShort: "Ready for MOJ",
			kind: "blue",
			variant: "outlined",
			noteRequired: false,
		},
		{
			value: 20,
			key: "SentToMOJ",
			label: "Sent to MOJ",
			kind: "blue",
			variant: "solid",
			noteRequired: false,
		},
		{
			value: 100,
			key: "MOJClean",
			label: "MOJ OK",
			kind: "green",
			variant: "solid",
			noteRequired: false,
			uploadRequired: true,
		},
		{
			value: 101,
			label: "MOJ Note",
			key: "MOJNote",
			kind: "orange",
			variant: "solid",
			noteRequired: true,
			uploadRequired: true,
		},
		{
			value: 200,
			label: "MOJ Fail",
			key: "MOJFail",
			kind: "red",
			variant: "solid",
			noteRequired: true,
		},
	],
	candidateArchivedReason: [
		{
			value: 10,
			label: "Hired",
		},
		{
			value: 20,
			label: "Rejected",
		},
		{
			value: 30,
			label: "Other",
		},
	],
	internalTasks: [
		{
			slug: "create-login",
			label: "Create a login for Candidate",
			notes: "",
		},
		{
			slug: "printed-onboarding-pack",
			label: "Printed onboarding pack",
			notes:
				"Including username / password, draft contract, IRD forms, MECA Booklet",
		},
		{
			slug: "provided-onboarding-pack",
			label: "Provided onboarding pack to Candidate",
			notes: "",
		},
		{ slug: "moj-check-id", label: "MOJ Sighted IDs", notes: "" },
		{ slug: "moj-check", label: "MOJ Check Completed", notes: "" },
		{
			slug: "sighted-ird",
			label: "Sighted IRD Forms (IR330, KiwiSaver)",
			notes: "",
		},
		{
			slug: "checked-all-answers",
			label: "Checked all answers provided by Candidate",
			notes: "",
		},
		{
			slug: "completed-offer",
			label: "Completed offer step to candidate",
			notes: "",
		},
		{ slug: "id-badge", label: "PPCS ID Badge issue", notes: "" },
		{
			slug: "supervisor-informed",
			label: "Supervisor informed (email/mobile)",
			notes: "",
		},
		{ slug: "zambion", label: "Completed entry to Zambion", notes: "" },
		{
			slug: "user-provision-form",
			label: "User Provision Form (PIL Only)",
			notes: "",
		},
		{
			slug: "basic-site-induction",
			label: "Basic and Site Induction",
			notes: "",
		},
		{ slug: "final-check", label: "Final Check", notes: "" },
	],
	VisaCommentRestriction:[
		{
			value: "None",
			label: "None",
		},
		{
			value: "Max 25 hours per week at all times",
			label: "Max 25 hours per week at all times",
		},
		{
			value: "Max 25 hours per week except during scheduled study breaks",
			label: "Max 25 hours per week except during scheduled study breaks",
		},
		{
			value: "Max 20 hours per week at all times",
			label: "Max 20 hours per week at all times",
		},
		{
			value: "Max 20 hours per week except during scheduled study breaks",
			label: "Max 20 hours per week except during scheduled study breaks",
		},
		{
			value: "Closed Work Visa - may only work in role stated on visa",
			label: "Closed Work Visa - may only work in role stated on visa",
		},
		{
			value: "Open Visa  - valid until expiry",
			label: "Open Visa  - valid until expiry",
		},
		{
			value: "WHV 3 months per employer",
			label: "WHV 3 months per employer",
		},
		{
			value: "WHV 6 months per employer",
			label: "WHV 6 months per employer",
		},
		{
			value: "WHV 9 months per employer",
			label: "WHV 9 months per employer",
		},
		{
			value: "WHV 12 months per employer",
			label: "WHV 12 months per employer",
		},
		{
			value: "Work Visa - AEWV",
			label: "Work Visa - AEWV",
		},
	],
	WorkRegions:[
		{
			value: "Northern",
			label: "Northern",
		},
		{
			value: "Central",
			label: "Central",
		},
		{
			value: "Southern",
			label: "Southern",
		},
	],
};
export default enums;
